import React, { useEffect, useState, useRef } from 'react'
// React Router
import { useNavigate } from 'react-router-dom'
// Ant Design
import { Flex, Typography, Button, Input, Select, Image, Radio, message, Space, Tag, Alert, Popover, Divider, Modal, Badge, Avatar } from 'antd'
// Ant Design Icons
import { CheckOutlined, PlusOutlined, DeleteOutlined, CloseOutlined, MinusOutlined, UpOutlined, RightOutlined, ArrowLeftOutlined, PushpinOutlined, DownCircleOutlined, QuestionCircleOutlined } from '@ant-design/icons'
// React Icons
import { LuAmpersand, LuBetweenHorizontalStart } from "react-icons/lu"
import { FaGripLinesVertical } from "react-icons/fa6"
// Assets
import Pastel from '../../Assets/Pastel.png'
import Barras from '../../Assets/Barra.jpg'
import Dona from '../../Assets/Dona.png'
import Medidor from '../../Assets/Medidor.png'
import Puntos from '../../Assets/Puntos.png'
// Axios
import axios from 'axios'
// Config
import config from '../../config'
import { getConfig } from '../../config'

export const Content = ({t}) => {

    const { Text } = Typography
    const [messageApi, contextHolder] = message.useMessage()
    const navigate = useNavigate()
    const [phase, setPhase] = useState(1)
    const [dataApi, setDataApi] = useState({})
    const [showFour, setShowFour] = useState("1")
    const [dataColumns, setDataColumns] = useState([])
    const [arrOperations, setArrOperations] = useState([])
    const [loading, setLoading] = useState(false)


    const saveGraph = async () => {
        setLoading(true)
        try {
            const res = await axios.post(config.urlApi + "/private/report", dataApi, {
                withCredentials: true,
            })
            if(res.status === 201) {
                navigate("/list")
                localStorage.setItem("alertReport", "true")
                setLoading(false)
            }
        }
        catch (error) {
            setLoading(false)
            if(error.status === 413) {
                messageApi.error(t("error_413_reports"))
            }
            else if(error.status === 409) {
                messageApi.error(t("error_409_graph"))
            }
            else if (error.status === 401) {
                navigate("/")
            }
            else {
                messageApi.error(t("error_create_graph"))
            }
        }
    }
    useEffect(() => {
        if(dataApi.indicators !== undefined) {
            saveGraph()
        }
    }, [dataApi])





    function Phase1() {
        const [nameReport, setNameReport] = useState("")
        const [fields, setFields] = useState([])
        const [items, setItems] = useState([])
        const [name, setName] = useState('')
        const inputRef = useRef(null)

        const addField = () => {
            setFields([...fields, { id: fields.length+1, name: "", description: "", type: null }])
        }

        const minField = () => {
            if (fields.length === 1) {
                return
            }
            const newFields = fields.filter((field, index) => index !== fields.length-1)
            setFields(newFields)
        }

        const onCampo = (e, id) => {
            const newFields = fields.map(field => {
                if (field.id === id) {
                    field.name = e.target.value
                }
                return field
            })
            setFields(newFields)
        }

        const onDescripcion = (e, id) => {
            const newFields = fields.map(field => {
                if (field.id === id) {
                    field.description = e.target.value
                }
                return field
            })
            setFields(newFields)
        }

        const onTipo = (value, id) => {
            const newFields = fields.map(field => {
                if (field.id === id) {
                    field.type = value

                    if (value === "date") {
                        field.date = null
                        delete field.predefined
                    }
                    else if (value === "predefined") {
                        field.predefined = null
                        delete field.date
                    }
                    else {
                        delete field.date
                        delete field.predefined
                    }
                }
                return field
            })
            setFields(newFields)
        }

        const onDate = (value, id) => {
            const newFields = fields.map(field => {
                if (field.id === id) {
                    field.date = value
                }
                return field
            })
            setFields(newFields)
        }

        const onNext = () => {
            if(nameReport === "") {
                return messageApi.info(t("add_name_graph"))
            }

            for (let i = 0; i < fields.length; i++) {
                if (fields[i].name === "" || fields[i].description === "" || fields[i].type === "" || fields[i].type === null) {
                    return messageApi.info(t("fill_all_fields"))
                }
                if (fields[i].type === "date" && fields[i].date === "") {
                    return messageApi.info(t("select_format_date"))
                }
                if (fields[i].type === "predefined" && (fields[i].predefined === null || fields[i].predefined.length === 0)) {
                    return messageApi.info(t("add_predefineds"))
                }
            }

            setDataApi(prevData => ({ ...prevData, fields: fields, report_name: nameReport }));
            setDataColumns(fields)
            setPhase(2)
        }

        useEffect(() => {
            if(dataApi.fields !== undefined) {
                setFields(dataApi.fields)
                setNameReport(dataApi.report_name)
            }
            else {
                setFields([
                    { id: 1, name: "", description: "", type: null }
                ])
            }
        }, [])

        const onNameChange = event => {
            setName(event.target.value);
        };
    
        const addItem = e => {
            if(name !== "") {
                e.preventDefault();
                setItems([...items, name]);
                setName('');
                setTimeout(() => {
                    var _a;
                    (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                }, 0);
            }
        };
    
        const onPredefined = (value, id) => {
            const newFields = fields.map(field => {
                if (field.id === id) {
                    field.predefined = value
                }
                return field
            })
            setFields(newFields)
        }

        return (
            <div className="skin-scroll-two" style={{ width: "100%", height: phase===1 ? "calc(100% - 235px)" : "60px", borderBottom: "1px solid #555050", overflowY: phase===1 ? "auto" : "hidden" }}>
                <Flex align="center" style={{ width: "100%", height: "60px", padding: "0 20px" }}>
                    <Flex justify="center" align="center" style={{ width: "35px", height: "35px", borderRadius: "50%", border: `1.2px solid ${getConfig("colorPrimario")}`, backgroundColor: phase!==1 && getConfig("colorPrimario") }}>
                        {phase!==1
                            ? <CheckOutlined style={{ color: "#fff" }} />
                            : <Text style={{ color: getConfig("colorPrimario"), fontSize: "16px" }}>1</Text>
                        }
                    </Flex>
                    <Text style={{ fontSize: "18px", marginLeft: "10px", color: "#000" }}>{t("upload_structure_data")}</Text>
                </Flex>

                {phase===1 && (
                    <>
                        <Flex style={{ width: "100%", padding: "0 20px", marginBottom: "20px" }}>
                            <Input onChange={(e) => setNameReport(e.target.value)} value={nameReport} placeholder={t("name_graph")} style={{ width: "100%" }} />
                        </Flex>
                        <Flex style={{ padding: "0 20px", position: "relative" }}>
                            <Flex vertical align="center" style={{ width: "100%", height: "100%" }}>
                                {fields.map(field => (
                                    <Flex key={field.id} justify="space-between" style={{ width: "100%", marginBottom: "20px" }}>
                                        <Input onChange={(e) => onCampo(e, field.id)} value={field.name} placeholder={t("field")} style={{ width: (field.date!==undefined || field.predefined!==undefined) ? "24%" : "30%" }} />
                                        <Input onChange={(e) => onDescripcion(e, field.id)} value={field.description} placeholder={t("description")} maxLength={40} style={{ width: (field.date!==undefined || field.predefined!==undefined) ? "24%" : "30%" }} />
                                        <Select
                                            placeholder={t("type")}
                                            style={{ width: (field.date!==undefined || field.predefined!==undefined) ? "24%" : "30%" }}
                                            onChange={(value) => onTipo(value, field.id)}
                                            options={[
                                                { value: "text", label: t("text") },
                                                { value: "number", label: t("number") },
                                                { value: "percentage", label: t("percent") },
                                                { value: "date", label: t("date_time") },
                                                { value: "predefined", label: t("predefined") },
                                            ]}
                                            value={field.type}
                                        />
                                        {field.date!==undefined &&
                                            <Select
                                                placeholder={t("format")}
                                                style={{ width: "24%" }}
                                                onChange={(value) => onDate(value, field.id)}
                                                value={field.date}
                                                options={[
                                                    { value: "MM/dd/yyyy", label: "MM/dd/yyyy" },
                                                    { value: "MM-dd-yyyy", label: "MM-dd-yyyy" },
                                                    { value: "dd/MM/yyyy", label: "dd/MM/yyyy" },
                                                    { value: "dd-MM-yyyy", label: "dd-MM-yyyy" },
                                                    { value: "MM/dd/yy HH:mm:ss", label: "MM/dd/yy HH:mm:ss" },
                                                    { value: "MM-dd-yy HH:mm:ss", label: "MM-dd-yy HH:mm:ss" },
                                                    { value: "MM/dd/yy hh:mm:ss a", label: "MM/dd/yy hh:mm:ss a" },
                                                    { value: "MM/dd/yy hh:mm a", label: "MM/dd/yy hh:mm a" },
                                                    { value: "MM/dd/yy HH:mm", label: "MM/dd/yy HH:mm" },
                                                    { value: "dd/MM/yy HH:mm:ss", label: "dd/MM/yy HH:mm:ss" },
                                                    { value: "dd/MM/yy hh:mm:ss a", label: "dd/MM/yy hh:mm:ss a" },
                                                    { value: "dd/MM/yy HH:mm", label: "dd/MM/yy HH:mm" },
                                                    { value: "dd/MM/yy hh:mm a", label: "dd/MM/yy hh:mm a" },
                                                    { value: "dd-MM-yy hh:mm a", label: "dd-MM-yy hh:mm a" },
                                                    { value: "yyy-MM-dd HH:mm:ss", label: "yyy-MM-dd HH:mm:ss" },
                                                    { value: "dd MMMM yyyy hh:mm a", label: "dd MMMM yyyy hh:mm a" },
                                                    { value: "dd MMM, yyyy HH:mm:ss", label: "dd MMM, yyyy HH:mm:ss" },
                                                    { value: "MILLI", label: "MILLI" },
                                                    { value: "HH:mm:ss", label: "HH:mm:ss" },
                                                    { value: "HH:mm", label: "HH:mm" },
                                                    { value: "dd MMM yyyy z", label: "dd MMM yyyy z" },
                                                    { value: "dd MMM yyyy Z", label: "dd MMM yyyy Z" },
                                                ]}
                                            />
                                        }
                                        {field.predefined!==undefined &&
                                            <Select
                                                mode="multiple"
                                                style={{ width: "24%" }}
                                                placeholder={t("add_field_predefined")}
                                                value={field.predefined && field.predefined}
                                                onChange={(value) => onPredefined(value, field.id)}
                                                dropdownRender={menu => (
                                                    <>
                                                        {menu}
                                                        <Divider style={{ margin: '8px 0' }} />
                                                        <Space style={{ padding: '0 8px 4px' }}>
                                                            <Input
                                                                placeholder={t("add_predefined")}
                                                                ref={inputRef}
                                                                value={name}
                                                                onChange={onNameChange}
                                                                onKeyDown={e => e.stopPropagation()}
                                                            />
                                                            <Button type="text" icon={<PlusOutlined />} onClick={addItem}>{t("add")}</Button>
                                                        </Space>
                                                    </>
                                                )}
                                                options={items.map(item => ({ label: item, value: item }))}
                                            />
                                        }
                                    </Flex>
                                ))}

                                <Flex justify="space-evenly" align="center" style={{ width: "100%", height: "100%" }}>
                                    <Button onClick={addField} ghost icon={<PlusOutlined />}  style={{ color: getConfig("colorSecundario"), border: `1.5px solid ${getConfig("colorSecundario")}`, width: "150px", height: "32px" }} />

                                    {fields.length>1 && 
                                        <Button onClick={minField} ghost icon={<MinusOutlined />}  style={{ color: getConfig("colorSecundario"), border: `1.5px solid ${getConfig("colorSecundario")}`, width: "150px", height: "32px" }} />
                                    }
                                </Flex>

                                <Button onClick={onNext} ghost style={{ width: "200px", color: getConfig("colorPrimario"), border: `1.5px solid ${getConfig("colorPrimario")}`, margin: "20px 0" }}>{t("next")}</Button>
                            </Flex>
                        </Flex>
                    </>
                )}
            </div>
        )
    }






    function Phase2() {
        const [nameOr, setNameOr] = useState(null)
        const [nameBetween, setNameBetween] = useState(null)
        const [selectFilter, setSelectFilter] = useState(1)
        const [andValues, setAndValues] = useState([])
        const [orValues, setOrValues] = useState([])
        const [betweenValues, setBetweenValues] = useState([])
        const [holdAnd, setHoldAnd] = useState(false)
        const [holdOr, setHoldOr] = useState(false)
        const [holdBet, setHoldBet] = useState(false)

        useEffect(() => {
            if(dataApi.searchFilter !== undefined) {
                const operation = dataApi.searchFilter.logicOperator
                if(operation==="AND") {
                    setSelectFilter(1)
                    setAndValues(dataApi.searchFilter.values.map((value, index) => ({
                        id: index + 1,
                        fieldName: value.fieldName,
                        value: value.value,
                        type: value.type,
                        ...(value.date !== undefined && { date: value.date }),
                    })));

                    setOrValues([{
                        id: 1,
                        value: null,
                        type: null
                    }])
                    setBetweenValues([{
                        id: 1,
                        value: null,
                        type: null
                    }])
                }
                else if(operation==="OPTION") {
                    setSelectFilter(2)
                    setNameOr(dataApi.searchFilter.fieldName)
                    
                    setOrValues(dataApi.searchFilter.values.map((value, index) => ({
                        id: index + 1,
                        value: value.value,
                        type: value.type,
                        ...(value.date !== undefined && { date: value.date }),
                    })));

                    setAndValues([{
                        id: 1,
                        fieldName: null,
                        value: null,
                        type: null
                    }])
                    setBetweenValues([{
                        id: 1,
                        value: null,
                        type: null
                    }])
                }
                else if(operation==="BETWEEN") {
                    setSelectFilter(3)
                    setNameBetween(dataApi.searchFilter.fieldName)

                    setBetweenValues(dataApi.searchFilter.values.map((value, index) => ({
                        id: index + 1,
                        value: value.value,
                        type: value.type,
                        ...(value.date !== undefined && { date: value.date }),
                    })));

                    setAndValues([{
                        id: 1,
                        fieldName: null,
                        value: null,
                        type: null
                    }])
                    setOrValues([{
                        id: 1,
                        value: null,
                        type: null
                    }])
                }
            }
            else if(dataApi.superFilter !== undefined) {
                let and = false
                let or = false
                let bet = false

                dataApi.superFilter.forEach((filter) => {
                    if(filter.logicOperator === "AND") {
                        and = true
                    }
                    else if(filter.logicOperator === "OPTION") {
                        or = true
                    }
                    else if(filter.logicOperator === "BETWEEN") {
                        bet = true
                    }
                })

                if(and) {
                    setAndValues(dataApi.superFilter.find(filter => filter.logicOperator === "AND").values.map((value, index) => ({
                        id: index + 1,
                        fieldName: value.fieldName,
                        value: value.value,
                        type: value.type,
                        ...(value.date !== undefined && { date: value.date }),
                    })));
                    setHoldAnd(true)
                }
                else {
                    setAndValues([{
                        id: 1,
                        fieldName: null,
                        value: null,
                        type: null
                    }])
                }

                if(or) {
                    setNameOr(dataApi.superFilter.find(filter => filter.logicOperator === "OPTION").fieldName)
                    setOrValues(dataApi.superFilter.find(filter => filter.logicOperator === "OPTION").values.map((value, index) => ({
                        id: index + 1,
                        value: value.value,
                        type: value.type,
                        ...(value.date !== undefined && { date: value.date }),
                    })));
                    setHoldOr(true)
                }
                else {
                    setOrValues([{
                        id: 1,
                        value: null,
                        type: null
                    }])
                }

                if(bet) {
                    setNameBetween(dataApi.superFilter.find(filter => filter.logicOperator === "BETWEEN").fieldName)
                    setBetweenValues(dataApi.superFilter.find(filter => filter.logicOperator === "BETWEEN").values.map((value, index) => ({
                        id: index + 1,
                        value: value.value,
                        type: value.type,
                        ...(value.date !== undefined && { date: value.date }),
                    })));
                    setHoldBet(true)
                }
                else {
                    setBetweenValues([{
                        id: 1,
                        value: null,
                        type: null
                    }])
                }
            }
            else {
                setSelectFilter(1)
                setAndValues([{
                    id: 1,
                    fieldName: null,
                    value: null,
                    type: null
                }])
                setOrValues([{
                    id: 1,
                    value: null,
                    type: null
                }])
                setBetweenValues([{
                    id: 1,
                    value: null,
                    type: null
                }])
            }
        }, [])

        const onBack = () => setPhase(1)

        const addAnd = () => {
            setAndValues([...andValues, { id: andValues.length+1, fieldName: null, value: null, type: null }])
        }

        const minAnd = () => {
            const newAndValues = andValues.filter((and, index) => index !== andValues.length-1)
            setAndValues(newAndValues)
        }

        const clearAnd = () => {
            setSelectFilter(1)

            if(!holdOr) {
                setOrValues([{
                    id: 1,
                    value: null,
                    type: null
                }])
                setNameOr(null)
            }

            if(!holdBet) {
                setBetweenValues([{
                    id: 1,
                    value: null,
                    type: null
                }])
                setNameBetween(null)
            }
        }
        
        const cleanOr = () => {
            setSelectFilter(2)

            if(!holdAnd) {
                setAndValues([{
                    id: 1,
                    fieldName: null,
                    value: null,
                    type: null
                }])
            }

            if(!holdBet) {
                setBetweenValues([{
                    id: 1,
                    value: null,
                    type: null
                }])
                setNameBetween(null)
            }
        }
        
        const cleanBet = () => {
            setSelectFilter(3)

            if(!holdAnd) {
                setAndValues([{
                    id: 1,
                    fieldName: null,
                    value: null,
                    type: null
                }])
            }

            if(!holdOr) {
                setOrValues([{
                    id: 1,
                    value: null,
                    type: null
                }])
                setNameOr(null)
            }
        }

        const onFieldName = (e, id) => {
            const newAndValues = andValues.map(and => {
                if (and.id === id) {
                    and.fieldName = e.target.value
                }
                return and
            })
            setAndValues(newAndValues)
        }

        const onValue = (e, id) => {
            const newAndValues = andValues.map(and => {
                if (and.id === id) {
                    and.value = e.target.value
                }
                return and
            })
            setAndValues(newAndValues)
        }

        const onType = (value, id) => {
            const newAndValues = andValues.map(and => {
                if (and.id === id) {
                    and.type = value

                    if (value === "date") {
                        and.date = null
                    }
                    else {
                        delete and.date
                    }
                }
                return and
            })
            setAndValues(newAndValues)
        }

        const onDate = (value, id) => {
            const newFields = andValues.map(field => {
                if (field.id === id) {
                    field.date = value
                }
                return field
            })
            setAndValues(newFields)
        }

        const addOr = () => {
            setOrValues([...orValues, { id: orValues.length+1, value: null, type: null }])
        }

        const minOr = () => {
            const newOrValues = orValues.filter((and, index) => index !== orValues.length-1)
            setOrValues(newOrValues)
        }

        const onValueOr = (e, id) => {
            const newOrValues = orValues.map(and => {
                if (and.id === id) {
                    and.value = e.target.value
                }
                return and
            })
            setOrValues(newOrValues)
        }

        const onTypeOr = (value, id) => {
            const newOrValues = orValues.map(or => {
                if (or.id === id) {
                    or.type = value
                    
                    if (value === "date") {
                        or.date = null
                    }
                    else {
                        delete or.date
                    }
                }
                return or
            })
            setOrValues(newOrValues)
        }

        const onDateOr = (value, id) => {
            const newFields = orValues.map(field => {
                if (field.id === id) {
                    field.date = value
                }
                return field
            })
            setOrValues(newFields)
        }

        const addBetween = () => {
            setBetweenValues([...betweenValues, { id: betweenValues.length+1, value: null, type: null }])
        }

        const minBetween = () => {
            const newBetweenValues = betweenValues.filter((and, index) => index !== betweenValues.length-1)
            setBetweenValues(newBetweenValues)
        }

        const onValueBet = (e, id) => {
            const newBetweenValues = betweenValues.map(and => {
                if (and.id === id) {
                    and.value = e.target.value
                }
                return and
            })
            setBetweenValues(newBetweenValues)
        }

        const onTypeBet = (value, id) => {
            const newBetweenValues = betweenValues.map(bet => {
                if (bet.id === id) {
                    bet.type = value
                    
                    if (value === "date") {
                        bet.date = null
                    }
                    else {
                        delete bet.date
                    }
                }
                return bet
            })
            setBetweenValues(newBetweenValues)
        }

        const onDateBet = (value, id) => {
            const newFields = betweenValues.map(field => {
                if (field.id === id) {
                    field.date = value
                }
                return field
            })
            setBetweenValues(newFields)
        }
        
        const onNext = () => {
            let isAnd = false
            let isOr = false
            let isBet = false

            for (let i = 0; i < andValues.length; i++) {
                if (andValues[i].fieldName !== null && andValues[i].value !== null && andValues[i].type !== null) {
                    isAnd = true
                    break
                }
            }

            for (let i = 0; i < orValues.length; i++) {
                if (orValues[i].value !== null && orValues[i].type !== null) {
                    isOr = true
                    break
                }
            }

            for (let i = 0; i < betweenValues.length; i++) {
                if (betweenValues[i].value !== null && betweenValues[i].type !== null) {
                    isBet = true
                    break
                }
            }
            

            if((selectFilter === 1 && !isAnd) && (!holdOr && !holdBet)) {
                setPhase(3)
            }
            else if((selectFilter === 2 && !isOr) && (!holdAnd && !holdBet)) {
                setPhase(3)
            }
            else if((selectFilter === 3 && !isBet) && (!holdAnd && !holdOr)) {
                setPhase(3)
            }
            else {
                const countTrue = [holdAnd, holdOr, holdBet].filter(Boolean).length;
                if(countTrue > 1) {
                    let and
                    let or
                    let bet
                    
                    for (let i = 0; i < andValues.length; i++) {
                        if (andValues[i].fieldName !== null && andValues[i].value !== null && andValues[i].type !== null) {
                            and = true
                            break
                        }
                    }

                    for (let i = 0; i < orValues.length; i++) {
                        if (orValues[i].value !== null && orValues[i].type !== null) {
                            or = true
                            break
                        }
                    }

                    for (let i = 0; i < betweenValues.length; i++) {
                        if (betweenValues[i].value !== null && betweenValues[i].type !== null) {
                            bet = true
                            break
                        }
                    }

                    const superFilter = []
                    if(and) {
                        for (let i = 0; i < andValues.length; i++) {
                            if (andValues[i].fieldName === null || andValues[i].value === null || andValues[i].type === null) {
                                return messageApi.info(t("fill_all_fields"))
                            }
                        }
                        for (let i = 0; i < andValues.length; i++) {
                            if (andValues[i].type === "date" && andValues[i].date === null) {
                                return messageApi.info(t("select_format_date"))
                            }
                        }

                        const searchFilterAnd = {
                            fieldName: "AND",
                            logicOperator: "AND",
                            values: andValues.map(({ id, ...rest }) => rest)
                        }

                        superFilter.push(searchFilterAnd)
                    }
                    if(or) {
                        if (nameOr === null) {
                            return messageApi.info(t("add_name_field"))
                        }
                        if(orValues.length === 1) {
                            return messageApi.info(t("add_more_field"))
                        }
                        for (let i = 0; i < orValues.length; i++) {
                            if (orValues[i].value === null || orValues[i].type === null) {
                                return messageApi.info(t("fill_all_fields"))
                            }
                        }
                        for (let i = 0; i < orValues.length; i++) {
                            if (orValues[i].type === "date" && orValues[i].date === null) {
                                return messageApi.info(t("select_format_date"))
                            }
                        }
    
                        const searchFilterOr = {
                            fieldName: nameOr,
                            logicOperator: "OPTION",
                            values: orValues.map(({ id, ...rest }) => rest),
                        }

                        superFilter.push(searchFilterOr)
                    }
                    if(bet) {
                        if (nameBetween === null) {
                            return messageApi.info(t("add_name_field"))
                        }
                        if(betweenValues.length === 1) {
                            return messageApi.info(t("add_more_field"))
                        }
                        for (let i = 0; i < betweenValues.length; i++) {
                            if (betweenValues[i].value === null || betweenValues[i].type === null) {
                                return messageApi.info(t("fill_all_fields"))
                            }
                        }
                        for (let i = 0; i < betweenValues.length; i++) {
                            if (betweenValues[i].type === "date" && betweenValues[i].date === null) {
                                return messageApi.info(t("select_format_date"))
                            }
                        }
    
                        const searchFilterBet = {
                            fieldName: nameBetween,
                            logicOperator: "BETWEEN",
                            values: betweenValues.map(({ id, ...rest }) => rest),
                        }

                        superFilter.push(searchFilterBet)
                    }

                    setDataApi(prevData => ({ ...prevData, superFilter: superFilter }));
                    setPhase(3)
                }
                else if(countTrue === 0) {
                    if(selectFilter === 1) {
                        for (let i = 0; i < andValues.length; i++) {
                            if (andValues[i].fieldName === null || andValues[i].value === null || andValues[i].type === null) {
                                return messageApi.info(t("fill_all_fields"))
                            }
                        }
                        for (let i = 0; i < andValues.length; i++) {
                            if (andValues[i].type === "date" && andValues[i].date === null) {
                                return messageApi.info(t("select_format_date"))
                            }
                        }
    
                        const searchFilter = {
                            fieldName: "AND",
                            logicOperator: "AND",
                            values: andValues.map(({ id, ...rest }) => rest)
                        }
                        
                        setDataApi(prevData => ({ ...prevData, searchFilter: searchFilter }));
                        setPhase(3)
                    }
                    else if(selectFilter === 2) {
                        if (nameOr === null) {
                            return messageApi.info(t("add_name_field"))
                        }
                        if(orValues.length === 1) {
                            return messageApi.info(t("add_more_field"))
                        }
                        for (let i = 0; i < orValues.length; i++) {
                            if (orValues[i].value === null || orValues[i].type === null) {
                                return messageApi.info(t("fill_all_fields"))
                            }
                        }
                        for (let i = 0; i < orValues.length; i++) {
                            if (orValues[i].type === "date" && orValues[i].date === null) {
                                return messageApi.info(t("select_format_date"))
                            }
                        }
    
                        const searchFilter = {
                            fieldName: nameOr,
                            logicOperator: "OPTION",
                            values: orValues.map(({ id, ...rest }) => rest),
                        }
                        
                        setDataApi(prevData => ({ ...prevData, searchFilter: searchFilter }));
                        setPhase(3)
                    }
                    else if(selectFilter === 3) {
                        if (nameBetween === null) {
                            return messageApi.info(t("add_name_field"))
                        }
                        if(betweenValues.length === 1) {
                            return messageApi.info(t("add_more_field"))
                        }
                        for (let i = 0; i < betweenValues.length; i++) {
                            if (betweenValues[i].value === null || betweenValues[i].type === null) {
                                return messageApi.info(t("fill_all_fields"))
                            }
                        }
                        for (let i = 0; i < betweenValues.length; i++) {
                            if (betweenValues[i].type === "date" && betweenValues[i].date === null) {
                                return messageApi.info(t("select_format_date"))
                            }
                        }
    
                        const searchFilter = {
                            fieldName: nameBetween,
                            logicOperator: "BETWEEN",
                            values: betweenValues.map(({ id, ...rest }) => rest),
                        }
    
                        setDataApi(prevData => ({ ...prevData, searchFilter: searchFilter }));
                        setPhase(3)
                    }
                }
                else if(countTrue === 1) {
                    let and
                    let or
                    let bet
                    
                    for (let i = 0; i < andValues.length; i++) {
                        if (andValues[i].fieldName !== null && andValues[i].value !== null && andValues[i].type !== null) {
                            and = true
                            break
                        }
                    }

                    for (let i = 0; i < orValues.length; i++) {
                        if (orValues[i].value !== null && orValues[i].type !== null) {
                            or = true
                            break
                        }
                    }

                    for (let i = 0; i < betweenValues.length; i++) {
                        if (betweenValues[i].value !== null && betweenValues[i].type !== null) {
                            bet = true
                            break
                        }
                    }

                    const countTrue = [and, or, bet].filter(Boolean).length;

                    if(countTrue === 1) {
                        if(holdAnd) {
                            for (let i = 0; i < andValues.length; i++) {
                                if (andValues[i].fieldName === null || andValues[i].value === null || andValues[i].type === null) {
                                    return messageApi.info(t("fill_all_fields"))
                                }
                            }
                            for (let i = 0; i < andValues.length; i++) {
                                if (andValues[i].type === "date" && andValues[i].date === null) {
                                    return messageApi.info(t("select_format_date"))
                                }
                            }
    
                            const searchFilter = {
                                fieldName: "AND",
                                logicOperator: "AND",
                                values: andValues.map(({ id, ...rest }) => rest)
                            }
                            
                            setDataApi(prevData => ({ ...prevData, searchFilter: searchFilter }));
                            setPhase(3)
                        }
                        else if(holdOr) {
                            if (nameOr === null) {
                                return messageApi.info(t("add_name_field"))
                            }
                            if(orValues.length === 1) {
                                return messageApi.info(t("add_more_field"))
                            }
                            for (let i = 0; i < orValues.length; i++) {
                                if (orValues[i].value === null || orValues[i].type === null) {
                                    return messageApi.info(t("fill_all_fields"))
                                }
                            }
                            for (let i = 0; i < orValues.length; i++) {
                                if (orValues[i].type === "date" && orValues[i].date === null) {
                                    return messageApi.info(t("select_format_date"))
                                }
                            }
        
                            const searchFilter = {
                                fieldName: nameOr,
                                logicOperator: "OPTION",
                                values: orValues.map(({ id, ...rest }) => rest),
                            }
                            
                            setDataApi(prevData => ({ ...prevData, searchFilter: searchFilter }));
                            setPhase(3)
                        }
                        else if(holdBet) {
                            if (nameBetween === null) {
                                return messageApi.info(t("add_name_field"))
                            }
                            if(betweenValues.length === 1) {
                                return messageApi.info(t("add_more_field"))
                            }
                            for (let i = 0; i < betweenValues.length; i++) {
                                if (betweenValues[i].value === null || betweenValues[i].type === null) {
                                    return messageApi.info(t("fill_all_fields"))
                                }
                            }
                            for (let i = 0; i < betweenValues.length; i++) {
                                if (betweenValues[i].type === "date" && betweenValues[i].date === null) {
                                    return messageApi.info(t("select_format_date"))
                                }
                            }
        
                            const searchFilter = {
                                fieldName: nameBetween,
                                logicOperator: "BETWEEN",
                                values: betweenValues.map(({ id, ...rest }) => rest),
                            }
        
                            setDataApi(prevData => ({ ...prevData, searchFilter: searchFilter }));
                            setPhase(3)
                        }
                    }
                    else {
                        const superFilter = []
                        if(and) {
                            for (let i = 0; i < andValues.length; i++) {
                                if (andValues[i].fieldName === null || andValues[i].value === null || andValues[i].type === null) {
                                    return messageApi.info(t("fill_all_fields"))
                                }
                            }
                            for (let i = 0; i < andValues.length; i++) {
                                if (andValues[i].type === "date" && andValues[i].date === null) {
                                    return messageApi.info(t("select_format_date"))
                                }
                            }
    
                            const searchFilterAnd = {
                                fieldName: "AND",
                                logicOperator: "AND",
                                values: andValues.map(({ id, ...rest }) => rest)
                            }
    
                            superFilter.push(searchFilterAnd)
                        }
                        if(or) {
                            if (nameOr === null) {
                                return messageApi.info(t("add_name_field"))
                            }
                            if(orValues.length === 1) {
                                return messageApi.info(t("add_more_field"))
                            }
                            for (let i = 0; i < orValues.length; i++) {
                                if (orValues[i].value === null || orValues[i].type === null) {
                                    return messageApi.info(t("fill_all_fields"))
                                }
                            }
                            for (let i = 0; i < orValues.length; i++) {
                                if (orValues[i].type === "date" && orValues[i].date === null) {
                                    return messageApi.info(t("select_format_date"))
                                }
                            }
        
                            const searchFilterOr = {
                                fieldName: nameOr,
                                logicOperator: "OPTION",
                                values: orValues.map(({ id, ...rest }) => rest),
                            }
    
                            superFilter.push(searchFilterOr)
                        }
                        if(bet) {
                            if (nameBetween === null) {
                                return messageApi.info(t("add_name_field"))
                            }
                            if(betweenValues.length === 1) {
                                return messageApi.info(t("add_more_field"))
                            }
                            for (let i = 0; i < betweenValues.length; i++) {
                                if (betweenValues[i].value === null || betweenValues[i].type === null) {
                                    return messageApi.info(t("fill_all_fields"))
                                }
                            }
                            for (let i = 0; i < betweenValues.length; i++) {
                                if (betweenValues[i].type === "date" && betweenValues[i].date === null) {
                                    return messageApi.info(t("select_format_date"))
                                }
                            }
        
                            const searchFilterBet = {
                                fieldName: nameBetween,
                                logicOperator: "BETWEEN",
                                values: betweenValues.map(({ id, ...rest }) => rest),
                            }
    
                            superFilter.push(searchFilterBet)
                        }
    
                        setDataApi(prevData => ({ ...prevData, superFilter: superFilter }));
                        setPhase(3) 
                    }
                }
            }
        }

        const onHold = (type) => {
            if(type === "and") {
                if(holdAnd) {
                    setAndValues([{
                        id: 1,
                        fieldName: null,
                        value: null,
                        type: null
                    }])
                    setHoldAnd(false)
                }
                else {
                    setHoldAnd(true)
                }
            }
            else if(type === "option") {
                if(holdOr) {
                    setOrValues([{
                        id: 1,
                        value: null,
                        type: null
                    }])
                    
                    setNameOr(null)
                    setHoldOr(false)
                }
                else {
                    setHoldOr(true)
                }
            }
            else if(type === "bet") {
                if(holdBet) {
                    setBetweenValues([{
                        id: 1,
                        value: null,
                        type: null
                    }])
                    
                    setNameBetween(null)
                    setHoldBet(false)
                }
                else {
                    setHoldBet(true)
                }
            }
        }

        return (
            <div className="skin-scroll-two" style={{ width: "100%", height: phase===2 ? "calc(100% - 235px)" : "60px", borderBottom: "1px solid #555050", overflowY: phase===2 ? "auto" : "hidden" }}>
                <Flex align="center" style={{ width: "100%", height: "60px", padding: "0 20px" }}>
                    <Flex justify="center" align="center" style={{ width: "35px", height: "35px", borderRadius: "50%", border: phase===2 ? `1.2px solid ${getConfig("colorPrimario")}` : "1.2px solid #BFBFBF", backgroundColor: phase>2 && getConfig("colorPrimario") }}>
                        {phase>2
                            ? <CheckOutlined style={{ color: "#fff" }} />
                            : <Text style={{ color: phase===2 ? getConfig("colorPrimario") : "#BFBFBF", fontSize: "16px" }}>2</Text>
                        }
                    </Flex>
                    <Text style={{ fontSize: "18px", marginLeft: "10px", color: phase>=2 ? "#000" : "#BFBFBF" }}>{t("filter_search")} <span style={{ color: getConfig("colorPrimario"), visibility: phase!==2 ? "hidden" : "visible" }}>({t("optional")})</span></Text>
                </Flex>

                {phase===2 && (
                    <Flex vertical align="center">
                        <Flex style={{ width: "100%", height: "calc(100vh - 390px)", padding: "0 20px" }}>

                            <Flex vertical justify="space-around" style={{ width: "20%", height: "100%" }}>
                                <Flex onClick={clearAnd} justify="space-between" align="center" style={{ width: "100%", height: "50px", padding: "0 10px", borderBottom: (selectFilter===1 || holdAnd) ? `2px solid ${getConfig("colorPrimario")}` : "2px solid #eee", cursor: "pointer", transition: ".3s all ease" }}>
                                    <Flex align="center" gap={10}>
                                        <LuAmpersand style={{ fontSize: "18px", color: getConfig("colorPrimario") }} />
                                        <Text style={{ fontSize: "18px", opacity: (selectFilter===1 || holdAnd) ? 1 : 0.5 }}>FIND & AND</Text>
                                    </Flex>
                                    <RightOutlined style={{ color: (selectFilter===1 || holdAnd) && getConfig("colorPrimario") }} />
                                </Flex>
                                <Flex onClick={cleanBet} justify="space-between" align="center" style={{ width: "100%", height: "50px", padding: "0 10px", borderBottom: (selectFilter===3 || holdBet) ? `2px solid ${getConfig("colorPrimario")}` : "2px solid #eee", cursor: "pointer", transition: ".3s all ease" }}>
                                    <Flex align="center" gap={10}>
                                        <LuBetweenHorizontalStart style={{ fontSize: "18px", color: getConfig("colorPrimario") }} />
                                        <Text style={{ fontSize: "18px", opacity: (selectFilter===3 || holdBet) ? 1 : 0.5 }}>Between</Text>
                                    </Flex>
                                    <RightOutlined style={{ color: (selectFilter===3 || holdBet) && getConfig("colorPrimario") }} />
                                </Flex>
                                <Flex onClick={cleanOr} justify="space-between" align="center" style={{ width: "100%", height: "50px", padding: "0 10px", borderBottom: (selectFilter===2 || holdOr) ? `2px solid ${getConfig("colorPrimario")}` : "2px solid #eee", cursor: "pointer", transition: ".3s all ease" }}>
                                    <Flex align="center" gap={10}>
                                        <FaGripLinesVertical style={{ fontSize: "18px", color: getConfig("colorPrimario") }} />
                                        <Text style={{ fontSize: "18px", opacity: (selectFilter===2 || holdOr) ? 1 : 0.5 }}>OPTION</Text>
                                    </Flex>
                                    <RightOutlined style={{ color: (selectFilter===2 || holdOr) && getConfig("colorPrimario") }} />
                                </Flex>
                            </Flex>

                            <Flex className="skin-scroll" style={{ width: "80%", height: "100%", overflowY: "auto", paddingRight: "5px" }}>
                                {
                                    selectFilter===1 ? 
                                        <Flex vertical style={{ width: "100%", padding: "0 0 0 20px" }}>
                                            {andValues.map(and => (
                                                <Flex key={and.id} justify="space-between" style={{ width: "100%", marginBottom: "20px" }}>
                                                    <Input onChange={(e) => onFieldName(e, and.id)} value={and.fieldName} placeholder={t("name_field")} style={{ width: and.date!==undefined ? "22%" : "30%" }} />
                                                    <Input onChange={(e) => onValue(e, and.id)} value={and.value} placeholder={t("value")} style={{ width: and.date!==undefined ? "22%" : "30%" }} />
                                                    <Select
                                                        placeholder={t("type")}
                                                        style={{ width: and.date!==undefined ? "22%" : "30%" }}
                                                        onChange={(value) => onType(value, and.id)}
                                                        value={and.type}
                                                        options={[
                                                            { value: "text", label: t("text") },
                                                            { value: "number", label: t("number") },
                                                            { value: "date", label: t("date_time") },
                                                        ]}
                                                    />
                                                    {and.date!==undefined &&
                                                        <Select
                                                            placeholder={t("format")}
                                                            style={{ width: "22%" }}
                                                            onChange={(value) => onDate(value, and.id)}
                                                            value={and.date}
                                                            options={[
                                                                { value: "MM/dd/yyyy", label: "MM/dd/yyyy" },
                                                                { value: "MM-dd-yyyy", label: "MM-dd-yyyy" },
                                                                { value: "dd/MM/yyyy", label: "dd/MM/yyyy" },
                                                                { value: "dd-MM-yyyy", label: "dd-MM-yyyy" },
                                                                { value: "MM/dd/yy HH:mm:ss", label: "MM/dd/yy HH:mm:ss" },
                                                                { value: "MM-dd-yy HH:mm:ss", label: "MM-dd-yy HH:mm:ss" },
                                                                { value: "MM/dd/yy hh:mm:ss a", label: "MM/dd/yy hh:mm:ss a" },
                                                                { value: "MM/dd/yy hh:mm a", label: "MM/dd/yy hh:mm a" },
                                                                { value: "MM/dd/yy HH:mm", label: "MM/dd/yy HH:mm" },
                                                                { value: "dd/MM/yy HH:mm:ss", label: "dd/MM/yy HH:mm:ss" },
                                                                { value: "dd/MM/yy hh:mm:ss a", label: "dd/MM/yy hh:mm:ss a" },
                                                                { value: "dd/MM/yy HH:mm", label: "dd/MM/yy HH:mm" },
                                                                { value: "dd/MM/yy hh:mm a", label: "dd/MM/yy hh:mm a" },
                                                                { value: "dd-MM-yy hh:mm a", label: "dd-MM-yy hh:mm a" },
                                                                { value: "yyy-MM-dd HH:mm:ss", label: "yyy-MM-dd HH:mm:ss" },
                                                                { value: "dd MMMM yyyy hh:mm a", label: "dd MMMM yyyy hh:mm a" },
                                                                { value: "dd MMM, yyyy HH:mm:ss", label: "dd MMM, yyyy HH:mm:ss" },
                                                                { value: "MILLI", label: "MILLI" },
                                                                { value: "HH:mm:ss", label: "HH:mm:ss" },
                                                                { value: "HH:mm", label: "HH:mm" },
                                                                { value: "dd MMM yyyy z", label: "dd MMM yyyy z" },
                                                                { value: "dd MMM yyyy Z", label: "dd MMM yyyy Z" },
                                                            ]}
                                                        />
                                                    }
                                                </Flex>
                                            ))}
                        
                                            <Flex justify="space-evenly" style={{ width: "100%", marginBottom: "20px" }}>
                                                <Button onClick={addAnd} ghost icon={<PlusOutlined />} style={{ width: "120px", color: getConfig("colorSecundario"), border: `1.5px solid ${getConfig("colorSecundario")}` }} />
                        
                                                {andValues.length>1 && 
                                                    <Button onClick={minAnd} ghost icon={<MinusOutlined />} style={{ width: "120px", color: getConfig("colorSecundario"), border: `1.5px solid ${getConfig("colorSecundario")}` }} />
                                                }

                                                <Button onClick={() => onHold("and")} ghost icon={<PushpinOutlined />} style={{ width: "120px", backgroundColor: holdAnd && "#87D068", color: holdAnd ? "#fff" : "#87D068", border: "1.5px solid #87D068", transition: ".2s all ease" }}>{t("hold")}</Button>
                                            </Flex>
                                        </Flex>
                                    :
                                    selectFilter===2 ? 
                                        <Flex vertical style={{ width: "100%", padding: "0 0 0 20px" }}>
                                            <Input onChange={(e) => setNameOr(e.target.value)} value={nameOr} placeholder={t("name_field")} style={{ width: "100%", marginBottom: "20px" }} />
                        
                                            {orValues.map(or => (
                                                <Flex key={or.id} justify="space-between" style={{ width: "100%", marginBottom: "20px" }}>
                                                    <Input onChange={(e) => onValueOr(e, or.id)} value={or.value} placeholder={t("value")} style={{ width: or.date!==undefined ? "32%" : "48%" }} />
                                                    <Select 
                                                        placeholder={t("type")}
                                                        style={{ width: or.date!==undefined ? "32%" : "48%" }}
                                                        onChange={(value) => onTypeOr(value, or.id)}
                                                        value={or.type} 
                                                        options={[
                                                            { value: "text", label: t("text") },
                                                            { value: "number", label: t("number") },
                                                            { value: "date", label: t("date_time") },
                                                        ]}
                                                    />
                                                    {or.date!==undefined &&
                                                        <Select
                                                            placeholder={t("format")}
                                                            style={{ width: "32%" }}
                                                            onChange={(value) => onDateOr(value, or.id)}
                                                            value={or.date}
                                                            options={[
                                                                { value: "MM/dd/yyyy", label: "MM/dd/yyyy" },
                                                                { value: "MM-dd-yyyy", label: "MM-dd-yyyy" },
                                                                { value: "dd/MM/yyyy", label: "dd/MM/yyyy" },
                                                                { value: "dd-MM-yyyy", label: "dd-MM-yyyy" },
                                                                { value: "MM/dd/yy HH:mm:ss", label: "MM/dd/yy HH:mm:ss" },
                                                                { value: "MM-dd-yy HH:mm:ss", label: "MM-dd-yy HH:mm:ss" },
                                                                { value: "MM/dd/yy hh:mm:ss a", label: "MM/dd/yy hh:mm:ss a" },
                                                                { value: "MM/dd/yy hh:mm a", label: "MM/dd/yy hh:mm a" },
                                                                { value: "MM/dd/yy HH:mm", label: "MM/dd/yy HH:mm" },
                                                                { value: "dd/MM/yy HH:mm:ss", label: "dd/MM/yy HH:mm:ss" },
                                                                { value: "dd/MM/yy hh:mm:ss a", label: "dd/MM/yy hh:mm:ss a" },
                                                                { value: "dd/MM/yy HH:mm", label: "dd/MM/yy HH:mm" },
                                                                { value: "dd/MM/yy hh:mm a", label: "dd/MM/yy hh:mm a" },
                                                                { value: "dd-MM-yy hh:mm a", label: "dd-MM-yy hh:mm a" },
                                                                { value: "yyy-MM-dd HH:mm:ss", label: "yyy-MM-dd HH:mm:ss" },
                                                                { value: "dd MMMM yyyy hh:mm a", label: "dd MMMM yyyy hh:mm a" },
                                                                { value: "dd MMM, yyyy HH:mm:ss", label: "dd MMM, yyyy HH:mm:ss" },
                                                                { value: "MILLI", label: "MILLI" },
                                                                { value: "HH:mm:ss", label: "HH:mm:ss" },
                                                                { value: "HH:mm", label: "HH:mm" },
                                                                { value: "dd MMM yyyy z", label: "dd MMM yyyy z" },
                                                                { value: "dd MMM yyyy Z", label: "dd MMM yyyy Z" },
                                                            ]}
                                                        />
                                                    }
                                                </Flex>
                                            ))}
                        
                                            <Flex justify="space-evenly" style={{ width: "100%", marginBottom: "20px" }}>
                                                <Button onClick={addOr} ghost icon={<PlusOutlined />}  style={{ width: "120px", color: getConfig("colorSecundario"), border: `1.5px solid ${getConfig("colorSecundario")}` }} />
                        
                                                {orValues.length>1 && 
                                                    <Button onClick={minOr} ghost icon={<MinusOutlined />}  style={{ width: "120px", color: getConfig("colorSecundario"), border: `1.5px solid ${getConfig("colorSecundario")}` }} />
                                                }

                                                <Button onClick={() => onHold("option")} ghost icon={<PushpinOutlined />} style={{ width: "120px", backgroundColor: holdOr && "#87D068", color: holdOr ? "#fff" : "#87D068", border: "1.5px solid #87D068", transition: ".2s all ease" }}>{t("hold")}</Button>
                                            </Flex>
                                        </Flex>
                                    :
                                    selectFilter===3 ?
                                        <Flex vertical style={{ width: "100%", padding: "0 0 0 20px" }}>
                                            <Input onChange={(e) => setNameBetween(e.target.value)} value={nameBetween} placeholder={t("name_field")} style={{ width: "100%", marginBottom: "20px" }} />
                        
                                            {betweenValues.map(bet => (
                                                <Flex key={bet.id} justify="space-between" style={{ width: "100%", marginBottom: "20px" }}>
                                                    <Input onChange={(e) => onValueBet(e, bet.id)} value={bet.value} placeholder={t("value")} style={{ width: bet.date!==undefined ? "32%" : "48%" }} />
                                                    <Select
                                                        placeholder={t("type")}
                                                        style={{ width: bet.date!==undefined ? "32%" : "48%" }} 
                                                        onChange={(value) => onTypeBet(value, bet.id)}
                                                        value={bet.type}
                                                        options={[
                                                            { value: "number", label: t("number") },
                                                            { value: "date", label: t("date_time") },
                                                        ]}
                                                    />
                                                    {bet.date!==undefined &&
                                                        <Select
                                                            placeholder={t("format")}
                                                            style={{ width: "32%" }}
                                                            onChange={(value) => onDateBet(value, bet.id)}
                                                            value={bet.date}
                                                            options={[
                                                                { value: "MM/dd/yyyy", label: "MM/dd/yyyy" },
                                                                { value: "MM-dd-yyyy", label: "MM-dd-yyyy" },
                                                                { value: "dd/MM/yyyy", label: "dd/MM/yyyy" },
                                                                { value: "dd-MM-yyyy", label: "dd-MM-yyyy" },
                                                                { value: "MM/dd/yy HH:mm:ss", label: "MM/dd/yy HH:mm:ss" },
                                                                { value: "MM-dd-yy HH:mm:ss", label: "MM-dd-yy HH:mm:ss" },
                                                                { value: "MM/dd/yy hh:mm:ss a", label: "MM/dd/yy hh:mm:ss a" },
                                                                { value: "MM/dd/yy hh:mm a", label: "MM/dd/yy hh:mm a" },
                                                                { value: "MM/dd/yy HH:mm", label: "MM/dd/yy HH:mm" },
                                                                { value: "dd/MM/yy HH:mm:ss", label: "dd/MM/yy HH:mm:ss" },
                                                                { value: "dd/MM/yy hh:mm:ss a", label: "dd/MM/yy hh:mm:ss a" },
                                                                { value: "dd/MM/yy HH:mm", label: "dd/MM/yy HH:mm" },
                                                                { value: "dd/MM/yy hh:mm a", label: "dd/MM/yy hh:mm a" },
                                                                { value: "dd-MM-yy hh:mm a", label: "dd-MM-yy hh:mm a" },
                                                                { value: "yyy-MM-dd HH:mm:ss", label: "yyy-MM-dd HH:mm:ss" },
                                                                { value: "dd MMMM yyyy hh:mm a", label: "dd MMMM yyyy hh:mm a" },
                                                                { value: "dd MMM, yyyy HH:mm:ss", label: "dd MMM, yyyy HH:mm:ss" },
                                                                { value: "MILLI", label: "MILLI" },
                                                                { value: "HH:mm:ss", label: "HH:mm:ss" },
                                                                { value: "HH:mm", label: "HH:mm" },
                                                                { value: "dd MMM yyyy z", label: "dd MMM yyyy z" },
                                                                { value: "dd MMM yyyy Z", label: "dd MMM yyyy Z" },
                                                            ]}
                                                        />
                                                    }
                                                </Flex>
                                            ))}
                        
                                            <Flex justify="space-evenly" style={{ width: "100%", marginBottom: "20px" }}>
                                                <Button onClick={addBetween} ghost icon={<PlusOutlined />}  style={{ width: "120px", color: getConfig("colorSecundario"), border: `1.5px solid ${getConfig("colorSecundario")}` }} />
                        
                                                {betweenValues.length>1 && 
                                                    <Button onClick={minBetween} ghost icon={<MinusOutlined />}  style={{ width: "120px", color: getConfig("colorSecundario"), border: `1.5px solid ${getConfig("colorSecundario")}` }} />
                                                }

                                                <Button onClick={() => onHold("bet")} ghost icon={<PushpinOutlined />} style={{ width: "120px", backgroundColor: holdBet && "#87D068", color: holdBet ? "#fff" : "#87D068", border: "1.5px solid #87D068", transition: ".2s all ease" }}>{t("hold")}</Button>
                                            </Flex>
                                        </Flex>
                                    : null
                                }
                            </Flex>

                        </Flex>

                        <Flex gap={30} style={{ marginBottom: "20px" }}>
                            <Button onClick={onNext} ghost style={{ width: "200px", color: getConfig("colorPrimario"), border: `1.5px solid ${getConfig("colorPrimario")}`, marginTop: "20px" }}>{t("next")}</Button>
                            <Button onClick={onBack} ghost style={{ width: "200px", color: getConfig("colorPrimario"), border: `1.5px solid ${getConfig("colorPrimario")}`, marginTop: "20px" }}>{t("back")}</Button>
                        </Flex>
                    </Flex>
                )}
            </div>
        )
    }





    function Phase3() {
        const [graph, setGraph] = useState("")

        const onNext = () => {
            if (graph === "") {
                return messageApi.info(t("select_type_graph"))
            }

            if(graph === "medidor" || graph === "dona" || graph === "pastel" || graph==="lineas") {
                setShowFour("2")
            }
            else if(graph === "card") {
                setShowFour("3")
            }
            else {
                setShowFour("1")
            }

            setDataApi(prevData => ({ ...prevData, graph_type: graph }));
            setPhase(4)
        }

        const onBack = () => {
            setPhase(2)
        }

        return (
            <div style={{ width: "100%", height: phase===3 ? "calc(100% - 235px)" : "60px", borderBottom: "1px solid #555050" }}>
                <Flex align="center" style={{ width: "100%", height: "60px", padding: "0 20px" }}>
                    <Flex justify="center" align="center" style={{ width: "35px", height: "35px", borderRadius: "50%", border: phase===3 ? `1.2px solid ${getConfig("colorPrimario")}` : "1.2px solid #BFBFBF", backgroundColor: phase>3 && getConfig("colorPrimario") }}>
                        {phase>3
                            ? <CheckOutlined style={{ color: "#fff" }} />
                            : <Text style={{ color: phase===3 ? getConfig("colorPrimario") : "#BFBFBF", fontSize: "16px" }}>3</Text>
                        }
                    </Flex>
                    <Text style={{ fontSize: "18px", marginLeft: "10px", color: phase>=3 ? "#000" : "#BFBFBF" }}>{t("type_graph")}</Text>
                </Flex>

                {phase===3 && (
                    <Flex vertical align="center">
                        <Flex justify="space-evenly" align="flex-end" style={{ width: "100%" }}>
                            <Flex vertical align="center">
                                <Image src={Pastel} width={100} alt="Graph" />
                                <Radio
                                    onClick={() => setGraph("pastel")}
                                    checked={graph==="pastel"}
                                    style={{ marginTop: "10px" }}
                                />
                            </Flex>
                            <Flex vertical align="center">
                                <Image src={Barras} width={100} alt="Graph" />
                                <Radio
                                    onClick={() => setGraph("barras")}
                                    checked={graph==="barras"}
                                    style={{ marginTop: "10px" }}
                                />
                            </Flex>
                            <Flex vertical align="center">
                                <Image src={Dona} width={100} alt="Graph" />
                                <Radio
                                    onClick={() => setGraph("dona")}
                                    checked={graph==="dona"}
                                    style={{ marginTop: "10px" }}
                                />
                            </Flex>
                            <Flex vertical align="center">
                                <Image src={Puntos} width={100} alt="Graph" />
                                <Radio
                                    onClick={() => setGraph("lineas")}
                                    checked={graph==="lineas"}
                                    style={{ marginTop: "10px" }}
                                />
                            </Flex>
                            <Flex vertical align="center">
                                <Image src={Medidor} width={220} alt="Graph" />
                                <Radio
                                    onClick={() => setGraph("medidor")}
                                    checked={graph==="medidor"}
                                    style={{ marginTop: "10px" }}
                                />
                            </Flex>
                            <Flex vertical align="center">
                                <Flex vertical justify="space-evenly" style={{ width: "150px", height: "80px", border: "4px solid #242124", borderRadius: "8px", padding: "10px", backgroundColor: "#fff" }}>
                                    <div style={{ width: "50%", height: "12px", backgroundColor: "#242124" }}></div>
                                    <div style={{ width: "100%", height: "12px", backgroundColor: "#242124", marginTop: "10px" }}></div>
                                </Flex>
                                <Radio
                                    onClick={() => setGraph("card")}
                                    checked={graph==="card"}
                                    style={{ marginTop: "10px" }}
                                />
                            </Flex>
                        </Flex>

                        <Flex gap={30}>
                            <Button onClick={onNext} ghost style={{ width: "200px", color: getConfig("colorPrimario"), border: `1.5px solid ${getConfig("colorPrimario")}`, marginTop: "20px" }}>{t("next")}</Button>
                            <Button onClick={onBack} ghost style={{ width: "200px", color: getConfig("colorPrimario"), border: `1.5px solid ${getConfig("colorPrimario")}`, marginTop: "20px" }}>{t("back")}</Button>
                        </Flex>
                    </Flex>
                )}
            </div>
        )
    }




    
    function Phase4() {
        const [nameOp, setNameOp] = useState("")
        const [operation, setOperation] = useState("")
        const [showCalcu, setShowCalcu] = useState(false)
        const inputOperationRef = useRef(null)
        const [cursorPos, setCursorPos] = useState(0)

        const addOperation = () => {
            if (nameOp === "" || operation === "") {
                messageApi.info(t("fill_all_fields"))
            }
            else if (operation.split("(").length !== operation.split(")").length) {
                messageApi.info(t("missing_parenthesis"))
            }
            else if(operation.split("[").length !== operation.split("]").length) {
                messageApi.info(t("missing_brackets"))
            }
            else {
                const nameNew = nameOp.replace(/\s+/g,"_")

                setArrOperations([...arrOperations, { id: arrOperations.length+1, name: nameNew, operation: operation }])

                const newOperation = {
                    id: dataApi.fields.length+1,
                    name: nameNew,
                    operation: operation
                }
                setDataColumns([...dataColumns, newOperation])

                setNameOp("")
                setOperation("")
            }
        }

        const deleteOperation = (index) => {
            const newOperations = arrOperations.filter((op, i) => i !== index)
            setArrOperations(newOperations)

            const deleteColumn = dataColumns.filter(col => col.name !== arrOperations[index].name)
            setDataColumns(deleteColumn)
        }

        const onNext = () => {
            if(arrOperations.length === 0) {
                return messageApi.info(t("add_more_operations"))
            }
            
            setDataApi(prevData => ({ ...prevData, custom_operators: arrOperations }));
            setPhase(5)
        }

        const onBack = () => {
            setPhase(3)
        }

        const ResaltarOperadores = (texto) => {
            const regex = /(\+|\-|\*|\/|\(|\)|:|,|\.|_|=|!|~|\[|\])/g;
            const partes = texto.split(regex);
        
            const matchedNames = [];
            let combined = partes.join('');
        
            const combinedRegex = new RegExp(dataColumns.map(tag => `(${tag.name})`).join('|'), 'g');
        
            const matches = [...combined.matchAll(combinedRegex)];
        
            matches.forEach(match => {
                matchedNames.push(match[0]);
                combined = combined.replace(match[0], '##');
            });
        
            const partesNuevas = combined.split(regex);

            const dataPredifined = dataColumns.filter(tag => tag.predefined !== undefined)
            const predifined = dataPredifined.map(tag => tag.predefined).flat()
            const regexPredifined = new RegExp(predifined.join('|'), 'g');
            
            const textoResaltado = partesNuevas.map((parte, index) => {
                if (parte.match(regex)) {
                    return (
                        <Tag key={index} color="red">
                            {parte}
                        </Tag>
                    );
                } 
                else if (parte.match(regexPredifined)) {
                    return (
                        <Tag key={index} color="geekblue">
                            {parte}
                        </Tag>
                    );
                }
                else if (/^[0-9]+$/.test(parte)) {
                    return (
                        <Tag key={index} color="green">
                            {parte}
                        </Tag>
                    );
                } 
                else if (parte.match(/COUNT|SUM|RANGE|UNIQUE|CROW|H|D|DT/g)) {
                    return (
                        <Tag key={index} color="red">
                            {parte}
                        </Tag>
                    );
                } 
                else if (parte === "") {
                    return null;
                }
                else {
                    return (
                        <Tag key={index} color="blue">
                            {parte}
                        </Tag>
                    );
                }
            });
        
            const updatedTextoResaltado = textoResaltado.map(element => {
                if (element === null) {
                    return null;
                }
                if (element.props.children === "##") {
                    const newValue = matchedNames.shift();
                    return React.cloneElement(element, { children: newValue });
                }
                return element;
            });
        
            return <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap" }}>{updatedTextoResaltado}</div>;
        };

        const deleteWord = () => {
            if (operation.length > 0 && cursorPos > 0) {
                const newValue = operation.slice(0, cursorPos - 1) + operation.slice(cursorPos);
                setOperation(newValue);
                setTimeout(() => {
                    if (inputOperationRef.current) {
                        inputOperationRef.current.focus();
                        inputOperationRef.current.setSelectionRange(cursorPos - 1, cursorPos - 1);
                        setCursorPos(cursorPos - 1);
                    }
                }, 0);
            }
        }

        const openCalculator = () => {
            if(!showCalcu) {
                setShowCalcu(true)
            }
        }

        const contentPredifined = (items) => {
            return (
                <Flex vertical>
                    {items.map((item, index) => (
                        <Button 
                            key={index+1} 
                            type="text" 
                            onClick={() => insertAtCursor(item)}
                        >
                            {item}
                        </Button>
                    ))}
                </Flex>
            )
        };

        const [isModalOpen, setIsModalOpen] = useState(false);
        const showModal = () => setIsModalOpen(true);
        const handleCancel = () => setIsModalOpen(false);


        const insertAtCursor = (text) => {
            if (inputOperationRef.current) {
                const start = cursorPos;
                const end = cursorPos;
                const value = operation;
                const newValue = value.slice(0, start) + text + value.slice(end);
                setOperation(newValue);
                setTimeout(() => {
                    inputOperationRef.current.focus();
                    inputOperationRef.current.setSelectionRange(start + text.length, start + text.length);
                    setCursorPos(start + text.length);
                }, 0);
            }
        };

        const hasUnclosedBrackets = (str) => {
            let paren = 0;
            let bracket = 0;
            for (let char of str) {
                if (char === '(') paren++;
                if (char === ')') paren--;
                if (char === '[') bracket++;
                if (char === ']') bracket--;
            }
            return paren !== 0 || bracket !== 0;
        };

        const [corchetes, setCorchetes] = useState(0)
        const [parentesis, setParentesis] = useState(0)
        const [isCrow, setIsCrow] = useState(false)

        useEffect(() => {
            const paren = (operation.match(/\(/g) || []).length - (operation.match(/\)/g) || []).length;
            const bracket = (operation.match(/\[/g) || []).length - (operation.match(/\]/g) || []).length;

            setCorchetes(bracket)
            setParentesis(paren)

            // Checar si existe el CROW en mi operacion
            if(operation.match(/CROW/g)) {
                setIsCrow(true)
            }
            else {
                setIsCrow(false)
            }
        }, [operation])

        return (
            <div className="skin-scroll-two" style={{ width: "100%", height: phase===4 ? "calc(100% - 235px)" : "60px", borderBottom: "1px solid #555050", overflowY: phase===4 ? "auto" : "hidden" }}>
                <Flex align="center" style={{ width: "100%", height: "60px", padding: "0 20px" }}>
                    <Flex justify="center" align="center" style={{ width: "35px", height: "35px", borderRadius: "50%", border: phase===4 ? `1.2px solid ${getConfig("colorPrimario")}` : "1.2px solid #BFBFBF", backgroundColor: phase>4 && getConfig("colorPrimario") }}>
                        {phase>4
                            ? <CheckOutlined style={{ color: "#fff" }} />
                            : <Text style={{ color: phase===4 ? getConfig("colorPrimario") : "#BFBFBF", fontSize: "16px" }}>4</Text>
                        }
                    </Flex>
                    <Text style={{ fontSize: "18px", marginLeft: "10px", color: phase>=4 ? "#000" : "#BFBFBF" }}>{t("custom_opt")}</Text>
                </Flex>

                {phase===4 && (
                    <Flex vertical align="center" style={{ padding: "0 20px" }}>
                        <Flex style={{ width: "100%" }}>
                            <Flex vertical style={{ position: "relative", width: "30%", height: "calc(100vh - 380px)", borderRight: "2px solid #eee", paddingRight: "10px", overflowY: "auto" }}>
                                {dataColumns.map(field => (
                                    <Flex key={field.id} justify="center" align="center" style={{ width: "100%", minHeight: "30px", maxHeight: "auto", position: "relative", border: "1px solid #888", borderRadius: "8px", padding: "5px 0", marginBottom: "10px", cursor: "pointer" }}>
                                        <Flex onClick={() => insertAtCursor(field.name)} justify="center" align="center" style={{ width: field.description ? "50%" : "100%", height: "100%", borderRight: field.description && "1.2px solid #888" }}>
                                            <Text style={{ fontSize: "14px", color: "#888" }}>{field.name} </Text>
                                        </Flex>
                                        {field.description &&
                                            <Flex onClick={() => insertAtCursor(field.name)} justify="center" align="center"  style={{ width: "50%", height: "100%", textAlign: "center", padding: "0 5px" }}>
                                                <Text style={{ fontSize: "14px", color: "#888" }}>{field.description}</Text>
                                            </Flex>
                                        }
                                        {field.predefined &&
                                            <Popover content={contentPredifined(field.predefined)} placement="bottom">
                                                <DownCircleOutlined style={{ position: "absolute", bottom: "-7px", left: "50%", transform: "translateX(-50%)", backgroundColor: "red", borderRadius: "50%", fontSize: "15px", color: "#fff" }} />
                                            </Popover>
                                        }
                                    </Flex>
                                ))}
                            </Flex>

                            <Flex vertical style={{ position: "relative", width: "70%", height: "calc(100vh - 410px)", padding: "0 10px" }}>
                                <Flex justify="space-between" align="center" style={{ width: "100%", maxHeight: "auto" }}>
                                    <Flex vertical style={{ width: "90%" }}>
                                        <Input onChange={(e) => setNameOp(e.target.value)} value={nameOp} placeholder={t("name_operator")} style={{ width: "100%", border: "1px solid #888", borderRadius: "8px" }} />
                                        <Flex align="flex-end" style={{ width: "100%" }}>
                                            {(corchetes>0 || parentesis>0) &&
                                                <Space size={12} style={{ paddingBottom: "2px", marginRight: "12px" }}>
                                                    {parentesis>0 &&
                                                        <Badge count={parentesis}  size="small">
                                                            <Avatar size="small" shape="square" style={{ backgroundColor: getConfig("colorPrimario") }}>(</Avatar>
                                                        </Badge>
                                                    }
                                                    {corchetes>0 &&
                                                        <Badge count={corchetes} size="small">
                                                            <Avatar size="small" shape="square" style={{ backgroundColor: getConfig("colorPrimario") }}>[</Avatar>
                                                        </Badge>
                                                    }
                                                </Space>
                                            }

                                            <Input
                                                ref={inputOperationRef}
                                                value={operation} 
                                                placeholder={t("operation")}
                                                style={{ width: "100%", border: hasUnclosedBrackets(operation) ? "1px solid red" : "1px solid #888", borderRadius: "8px", marginTop: "10px" }} 
                                                suffix={<CloseOutlined onClick={() => setOperation("")} style={{ fontSize: "14px", cursor: "pointer" }} />} 
                                                onSelect={e => setCursorPos(e.target.selectionStart)}
                                                onChange={e => setCursorPos(e.target.selectionStart)}
                                            />
                                        </Flex>
                                    </Flex>
                                    <Button onClick={addOperation} ghost icon={<PlusOutlined />} style={{ width: "8%", height: "50%", color: getConfig("colorSecundario"), border: `1.5px solid ${getConfig("colorSecundario")}` }} />
                                </Flex>

                                <Flex className="skin-scroll-two" vertical style={{ width: "100%", height: "75%", overflowY: "auto" }}>
                                    {arrOperations.map((op, index) =>
                                        <Flex key={index} gap={10} align="center" justify="space-between" style={{ width: "100%", marginTop: "10px", borderBottom: "1px solid #eee", padding: "5px 0" }}>
                                            <Text style={{ fontSize: "14px" }}>{op.name}</Text>
                                            <Flex style={{ fontSize: "14px" }}>{ResaltarOperadores(op.operation)}</Flex>
                                            <DeleteOutlined onClick={() => deleteOperation(index)} style={{ fontSize: "16px", color: "red", cursor: "pointer" }} />
                                        </Flex>
                                    )}
                                </Flex>

                                <Flex vertical style={{ position: "absolute", bottom: "-25px", right: "0", width: "340px", height: "auto", backgroundColor: "#4B4A4A", transition: "all 0.5s", borderRadius: "10px", padding: showCalcu ? "10px" : "2px 10px", zIndex: "1000" }}>
                                    <Flex onClick={openCalculator} justify="space-between" style={{ color: "#fff", fontSize: "12px", cursor: !showCalcu && "pointer" }}>
                                        <Text style={{ color: "#fff", textTransform: "uppercase" }}>{t("calculator")}</Text>
                                        {showCalcu
                                            ? 
                                                <Flex>
                                                    <QuestionCircleOutlined onClick={showModal} style={{ fontSize: "15px", marginRight: "10px", cursor: "pointer" }} />
                                                    <CloseOutlined onClick={() => setShowCalcu(false)} style={{ cursor: "pointer" }} />
                                                </Flex>
                                            : <UpOutlined />
                                        }
                                    </Flex>

                                    {showCalcu &&
                                        <Flex vertical style={{ width: "100%" }}>
                                            <Flex justify="space-between" style={{ width: "100%", marginTop: "10px" }}>
                                                {!isCrow &&
                                                    <Flex onClick={() => insertAtCursor("COUNT(")} justify="center" align="center" style={{ width: "36px", minHeight: "36px", backgroundColor: "#5491d0", color: "#fff", fontSize: "20px", borderRadius: "50%", cursor: "pointer" }}>C</Flex>
                                                }
                                                {!isCrow &&
                                                    <Flex onClick={() => insertAtCursor("SUM(")} justify="center" align="center" style={{ width: "36px", minHeight: "36px", backgroundColor: "#5491d0", color: "#fff", fontSize: "20px", borderRadius: "50%", cursor: "pointer" }}>S</Flex>
                                                }
                                                <Flex onClick={() => insertAtCursor("RANGE(")} justify="center" align="center" style={{ width: "36px", minHeight: "36px", backgroundColor: "#5491d0", color: "#fff", fontSize: "20px", borderRadius: "50%", cursor: "pointer" }}>R</Flex>
                                                {!isCrow &&
                                                    <Flex onClick={() => insertAtCursor("UNIQUE(")} justify="center" align="center" style={{ width: "36px", minHeight: "36px", backgroundColor: "#5491d0", color: "#fff", fontSize: "16px", borderRadius: "50%", cursor: "pointer" }}>U</Flex>
                                                }
                                                {!isCrow &&
                                                    <Flex onClick={() => insertAtCursor("CROW(")} justify="center" align="center" style={{ width: "36px", minHeight: "36px", backgroundColor: "#5491d0", color: "#fff", fontSize: "13px", borderRadius: "50%", cursor: "pointer" }}>CRW</Flex>
                                                }
                                                <Flex onClick={() => insertAtCursor("H")} justify="center" align="center" style={{ width: "36px", minHeight: "36px", backgroundColor: "#5491d0", color: "#fff", fontSize: "20px", borderRadius: "50%", cursor: "pointer" }}>H</Flex>
                                                <Flex onClick={() => insertAtCursor("D")} justify="center" align="center" style={{ width: "36px", minHeight: "36px", backgroundColor: "#5491d0", color: "#fff", fontSize: "20px", borderRadius: "50%", cursor: "pointer" }}>D</Flex>
                                                <Flex onClick={() => insertAtCursor("DT")} justify="center" align="center" style={{ width: "36px", minHeight: "36px", backgroundColor: "#5491d0", color: "#fff", fontSize: "16px", borderRadius: "50%", cursor: "pointer" }}>DT</Flex>
                                            </Flex>
                                            <Flex justify="space-between" style={{ width: "100%", marginTop: "10px" }}>
                                                <Flex onClick={() => insertAtCursor("7")} justify="center" align="center" style={{ width: "36px", minHeight: "36px", backgroundColor: "#757675", color: "#fff", fontSize: "20px", borderRadius: "50%", cursor: "pointer" }}>7</Flex>
                                                <Flex onClick={() => insertAtCursor("8")} justify="center" align="center" style={{ width: "36px", minHeight: "36px", backgroundColor: "#757675", color: "#fff", fontSize: "20px", borderRadius: "50%", cursor: "pointer" }}>8</Flex>
                                                <Flex onClick={() => insertAtCursor("9")} justify="center" align="center" style={{ width: "36px", minHeight: "36px", backgroundColor: "#757675", color: "#fff", fontSize: "20px", borderRadius: "50%", cursor: "pointer" }}>9</Flex>
                                                <Flex onClick={() => insertAtCursor("/")} justify="center" align="center" style={{ width: "36px", minHeight: "36px", backgroundColor: "#FF9500", color: "#fff", fontSize: "20px", borderRadius: "50%", cursor: "pointer" }}>/</Flex>
                                                <Flex onClick={() => insertAtCursor("(")} justify="center" align="center" style={{ width: "36px", minHeight: "36px", backgroundColor: "#FF9500", color: "#fff", fontSize: "20px", borderRadius: "50%", cursor: "pointer" }}>(</Flex>
                                                <Flex onClick={() => insertAtCursor(":")} justify="center" align="center" style={{ width: "36px", minHeight: "36px", backgroundColor: "#FF9500", color: "#fff", fontSize: "20px", borderRadius: "50%", cursor: "pointer" }}>:</Flex>
                                                <Flex onClick={() => insertAtCursor("=~")} justify="center" align="center" style={{ width: "36px", minHeight: "36px", backgroundColor: "#FF9500", color: "#fff", fontSize: "16px", borderRadius: "50%", cursor: "pointer" }}>=~</Flex>
                                            </Flex>
                                            <Flex justify="space-between" style={{ width: "100%", marginTop: "10px" }}>
                                                <Flex onClick={() => insertAtCursor("4")} justify="center" align="center" style={{ width: "36px", minHeight: "36px", backgroundColor: "#757675", color: "#fff", fontSize: "20px", borderRadius: "50%", cursor: "pointer" }}>4</Flex>
                                                <Flex onClick={() => insertAtCursor("5")} justify="center" align="center" style={{ width: "36px", minHeight: "36px", backgroundColor: "#757675", color: "#fff", fontSize: "20px", borderRadius: "50%", cursor: "pointer" }}>5</Flex>
                                                <Flex onClick={() => insertAtCursor("6")} justify="center" align="center" style={{ width: "36px", minHeight: "36px", backgroundColor: "#757675", color: "#fff", fontSize: "20px", borderRadius: "50%", cursor: "pointer" }}>6</Flex>
                                                <Flex onClick={() => insertAtCursor("*")} justify="center" align="center" style={{ width: "36px", minHeight: "36px", backgroundColor: "#FF9500", color: "#fff", fontSize: "20px", borderRadius: "50%", cursor: "pointer" }}>*</Flex>
                                                <Flex onClick={() => insertAtCursor(")")} justify="center" align="center" style={{ width: "36px", minHeight: "36px", backgroundColor: "#FF9500", color: "#fff", fontSize: "20px", borderRadius: "50%", cursor: "pointer" }}>)</Flex>
                                                <Flex onClick={() => insertAtCursor(",")} justify="center" align="center" style={{ width: "36px", minHeight: "36px", backgroundColor: "#FF9500", color: "#fff", fontSize: "20px", borderRadius: "50%", cursor: "pointer" }}>,</Flex>
                                                <Flex onClick={() => insertAtCursor("==")} justify="center" align="center" style={{ width: "36px", minHeight: "36px", backgroundColor: "#FF9500", color: "#fff", fontSize: "16px", borderRadius: "50%", cursor: "pointer" }}>==</Flex>
                                            </Flex>
                                            <Flex justify="space-between" style={{ width: "100%", marginTop: "10px" }}>
                                                <Flex onClick={() => insertAtCursor("1")} justify="center" align="center" style={{ width: "36px", minHeight: "36px", backgroundColor: "#757675", color: "#fff", fontSize: "20px", borderRadius: "50%", cursor: "pointer" }}>1</Flex>
                                                <Flex onClick={() => insertAtCursor("2")} justify="center" align="center" style={{ width: "36px", minHeight: "36px", backgroundColor: "#757675", color: "#fff", fontSize: "20px", borderRadius: "50%", cursor: "pointer" }}>2</Flex>
                                                <Flex onClick={() => insertAtCursor("3")} justify="center" align="center" style={{ width: "36px", minHeight: "36px", backgroundColor: "#757675", color: "#fff", fontSize: "20px", borderRadius: "50%", cursor: "pointer" }}>3</Flex>
                                                <Flex onClick={() => insertAtCursor("+")} justify="center" align="center" style={{ width: "36px", minHeight: "36px", backgroundColor: "#FF9500", color: "#fff", fontSize: "20px", borderRadius: "50%", cursor: "pointer" }}>+</Flex>
                                                <Flex onClick={() => insertAtCursor("[")} justify="center" align="center" style={{ width: "36px", minHeight: "36px", backgroundColor: "#FF9500", color: "#fff", fontSize: "20px", borderRadius: "50%", cursor: "pointer" }}>[</Flex>
                                                <Flex onClick={() => insertAtCursor(".")} justify="center" align="center" style={{ width: "36px", minHeight: "36px", backgroundColor: "#FF9500", color: "#fff", fontSize: "20px", borderRadius: "50%", cursor: "pointer" }}>.</Flex>
                                                <Flex onClick={() => insertAtCursor("!=")} justify="center" align="center" style={{ width: "36px", minHeight: "36px", backgroundColor: "#FF9500", color: "#fff", fontSize: "16px", borderRadius: "50%", cursor: "pointer" }}>!=</Flex>
                                            </Flex>
                                            <Flex justify="space-between" style={{ width: "100%", marginTop: "10px" }}>
                                                <Flex justify="center" align="center" style={{ width: "36px", minHeight: "36px", backgroundColor: "#757675", color: "#fff", fontSize: "20px", borderRadius: "50%", cursor: "pointer", opacity: 0 }}>(</Flex>
                                                <Flex onClick={() => insertAtCursor("0")} justify="center" align="center" style={{ width: "36px", minHeight: "36px", backgroundColor: "#757675", color: "#fff", fontSize: "20px", borderRadius: "50%", cursor: "pointer" }}>0</Flex>
                                                <Flex justify="center" align="center" style={{ width: "36px", minHeight: "36px", backgroundColor: "#757675", color: "#fff", fontSize: "20px", borderRadius: "50%", cursor: "pointer", opacity: 0 }}>)</Flex>
                                                <Flex onClick={() => insertAtCursor("-")} justify="center" align="center" style={{ width: "36px", minHeight: "36px", backgroundColor: "#FF9500", color: "#fff", fontSize: "20px", borderRadius: "50%", cursor: "pointer" }}>-</Flex>
                                                <Flex onClick={() => insertAtCursor("]")} justify="center" align="center" style={{ width: "36px", minHeight: "36px", backgroundColor: "#FF9500", color: "#fff", fontSize: "20px", borderRadius: "50%", cursor: "pointer" }}>]</Flex>
                                                <Flex onClick={() => insertAtCursor("_")} justify="center" align="center" style={{ width: "36px", minHeight: "36px", backgroundColor: "#FF9500", color: "#fff", fontSize: "20px", borderRadius: "50%", cursor: "pointer" }}>_</Flex>
                                                <Flex onClick={deleteWord} justify="center" align="center" style={{ width: "36px", minHeight: "36px", backgroundColor: "red", color: "#fff", fontSize: "20px", borderRadius: "50%", cursor: "pointer" }}><ArrowLeftOutlined style={{ fontSize: "14px" }} /></Flex>
                                            </Flex>
                                        </Flex>
                                    }
                                </Flex>
                            </Flex>
                        </Flex>
                        
                        <Flex gap={30}>
                            <Button onClick={onNext} ghost style={{ width: "200px", color: getConfig("colorPrimario"), border: `1.5px solid ${getConfig("colorPrimario")}`, margin: "20px 0" }}>{t("next")}</Button>
                            <Button onClick={onBack} ghost style={{ width: "200px", color: getConfig("colorPrimario"), border: `1.5px solid ${getConfig("colorPrimario")}`, margin: "20px 0" }}>{t("back")}</Button>
                        </Flex>
                    </Flex>
                )}

                <Modal
                    title={t("description_operators")}
                    closable={{ 'aria-label': 'Custom Close Button' }}
                    style={{ top: 20 }}
                    open={isModalOpen}
                    onCancel={handleCancel}
                    footer={null}
                    width={{
                        xs: '90%',
                        sm: '80%',
                        md: '70%',
                        lg: '70%',
                        xl: '70%',
                        xxl: '60%',
                    }}
                    bodyStyle={{
                        maxHeight: '80vh',
                        overflowY: 'auto',
                    }}
                >
                    <p><span style={{ fontWeight: "700" }}>COUNT (C):</span> {t("for_count")}</p>
                    <ul style={{ marginLeft: "20px", marginBottom: "10px", fontSize: "14px" }}>
                        <li>COUNT(TAG)</li>
                        <li>COUNT(TAG==PREDEFINED)</li>
                        <li>COUNT(TAG,TAG2==PREDEFINED)</li>
                    </ul>
                    
                    <p><span style={{ fontWeight: "700" }}>SUM (S):</span> {t("for_suma")}</p>
                    <ul style={{ marginLeft: "20px", marginBottom: "10px", fontSize: "14px" }}>
                        <li>SUM(TAG)</li>
                    </ul>

                    <p><span style={{ fontWeight: "700" }}>UNIQUE (U):</span> {t("for_unique")}</p>
                    <ul style={{ marginLeft: "20px", marginBottom: "10px", fontSize: "14px" }}>
                        <li>UNIQUE(TAG,TAG2)</li>
                    </ul>

                    <p><span style={{ fontWeight: "700" }}>RANGE (R):</span> {t("for_range")}</p>
                    <ul style={{ marginLeft: "20px", marginBottom: "10px", fontSize: "14px" }}>
                        <li>RANGE(TAG_001,7,10)</li>
                        <li>RANGE(TAG_001,DT13/03/2025_13:00,DT14/03/2025_16:00)</li>
                        <li>RANGE([(TAG_001+TAG_002)/6],0,4)</li>
                    </ul>

                    <p><span style={{ fontWeight: "700" }}>CROW (CRW):</span> {t("for_crow")}</p>
                    <ul style={{ marginLeft: "20px", marginBottom: "10px", fontSize: "14px" }}>
                        <li>CROW([TAG_001],[TAG_002])</li>
                        <li>CROW([TAG_001==ERROR],[TAG_002==ENVIADOS],[TAG_003==EXPIRED])</li>
                        <li>CROW([TAG_001==A],[TAG_002==CALL,SMS])</li>
                        <li>CROW([TAG_001],[TAG_002==ERROR],(RANGE([TAG_002+TAG_001)/2],0,5])</li>
                        <li>CROW([TAG_001],[TAG_002==ERROR],[TAG_003==EXPIRED],[RANGE(TAG_004,0,5)])</li>
                    </ul>

                    <p><span style={{ fontWeight: "700" }}>Hours (H):</span> {t("for_hours")}</p>
                    <ul style={{ marginLeft: "20px", marginBottom: "10px", fontSize: "14px" }}>
                        <li>RANGE(TAG,H13:00,H16:00)</li>
                    </ul>

                    <p><span style={{ fontWeight: "700" }}>Date (D):</span> {t("for_date")}</p>
                    <ul style={{ marginLeft: "20px", marginBottom: "10px", fontSize: "14px" }}>
                        <li>RANGE(TAG,D13/03/2025,D14/03/2025)</li>
                    </ul>

                    <p><span style={{ fontWeight: "700" }}>DT:</span> {t("for_datetime")}</p>
                    <ul style={{ marginLeft: "20px", marginBottom: "10px", fontSize: "14px" }}>
                        <li>RANGE(TAG,DT13/03/2025_13:00,DT14/03/2025_16:00)</li>
                    </ul>
                </Modal>
            </div>
        )
    }






    function Phase5() {

        const [ejeX, setEjeX] = useState("")
        const [ejeY, setEjeY] = useState("")
        const [title, setTitle] = useState("")
        const [columns, setColumns] = useState([])
        const [select, setSelect] = useState(null)

        const onNext = () => {
            if(columns.length === 0) {
                return messageApi.info(t("add_indicators"))
            }
            if(showFour==="1" && (ejeX === "" || ejeY === "")) {
                return messageApi.info(t("add_axies"))
            }
            if(showFour==="3" && title === "") {
                return messageApi.info(t("add_title"))
            }
            if(showFour==="3" && columns.length > 1) {
                return messageApi.info(t("select_one_indicator"))
            }
            if(dataApi.graph_type === "lineas" && columns.length > 1) {
                return messageApi.info(t("select_one_indicator"))
            }
            
            if(showFour==="1") {
                const ejes = {
                    x: ejeX,
                    y: ejeY
                }
                setDataApi(prevData => ({ ...prevData, axis: ejes, indicators: columns }));
            }
            else if(showFour==="3") {
                setDataApi(prevData => ({ ...prevData, title: title, indicators: columns }));
            }
            else {
                setDataApi(prevData => ({ ...prevData, indicators: columns }));
            }
        }

        const onBack = () => {
            setPhase(4)
            setDataApi(prevData => {
                const { indicators, axis, ...rest } = prevData;
                return rest;
            });
        }

        const addColumn = () => {
            if (select === null) {
                return messageApi.info(t("select_option"))
            }

            const newColumn = dataApi.custom_operators.find(col => col.name === select)
            const { operation, ...columnWithoutOperation } = newColumn;

            setColumns([...columns, columnWithoutOperation]);
            setSelect(null);
        }

        const deleteColumn = (index) => {
            const newColumns = columns.filter((col, i) => i !== index)
            setColumns(newColumns)
        }

        return (
            <div className="skin-scroll-two" style={{ width: "100%", height: phase===5 ? "calc(100% - 235px)" : "60px", borderBottom: "1px solid #555050", overflowY: phase===5 ? "auto" : "hidden" }}>
                <Flex align="center" style={{ width: "100%", height: "60px", padding: "0 20px" }}>
                    <Flex justify="center" align="center" style={{ width: "35px", height: "35px", borderRadius: "50%", border: phase===5 ? `1.2px solid ${getConfig("colorPrimario")}` : "1.2px solid #BFBFBF", backgroundColor: phase>5 && getConfig("colorPrimario") }}>
                        {phase>5
                            ? <CheckOutlined style={{ color: "#fff" }} />
                            : <Text style={{ color: phase===5 ? getConfig("colorPrimario") : "#BFBFBF", fontSize: "16px" }}>5</Text>
                        }
                    </Flex>
                    <Text style={{ fontSize: "18px", marginLeft: "10px", color: phase>=5 ? "#000" : "#BFBFBF" }}>{t("config_axies")}</Text>
                </Flex>

                {phase===5 && (
                    <Flex vertical align="center" style={{ padding: "0 20px" }}>
                        <Flex style={{ width: "100%" }}>

                            <Flex vertical style={{ width: (showFour==="1" || showFour==="3") ? "50%" : "100%", borderRight: (showFour==="1" || showFour==="3") && "2px solid #eee" }}>
                                <Text style={{ fontSize: "16px", color: getConfig("colorPrimario"), marginBottom: "5px" }}>{t("order_axis_x")}</Text>
                                <Space.Compact style={{ width: (showFour==="1" || showFour==="3") ? "94%" : "100%" }}>
                                    <Select
                                        placeholder={t("select_option")}
                                        style={{ width: "95%" }}
                                        options={dataApi.custom_operators.map(col => (
                                            { 
                                                value: col.name,
                                                label: col.name,
                                                disabled: columns.find(c => c.name === col.name) !== undefined
                                            }
                                        ))}
                                        onChange={(value) => setSelect(value)}
                                        value={select}
                                    />
                                    <Button onClick={addColumn} ghost icon={<PlusOutlined />} style={{ color: getConfig("colorSecundario"), border: `1.5px solid ${getConfig("colorSecundario")}` }} />
                                </Space.Compact>

                                <Flex className="skin-scroll-two" vertical style={{ width: (showFour==="1" || showFour==="3") ? "95%" : "100%", height: "120px", marginTop: "10px", overflowY: "auto", padding: showFour!=="1" && "0 10px" }}>
                                    {columns.map((col, index) =>
                                        <Flex key={index} justify="space-between" style={{ width: "100%", marginBottom: "10px", paddingRight: "5px" }}>
                                            <Alert message={col.name} type="success" />
                                            <DeleteOutlined onClick={() => deleteColumn(index)} style={{ fontSize: "16px", color: "red", cursor: "pointer" }} />
                                        </Flex>
                                    )}
                                </Flex>
                            </Flex>

                            {showFour==="1" &&
                                <Flex vertical style={{ width: "50%" }}>
                                    <Flex vertical align="center" style={{ width: "100%", marginBottom: "20px" }}>
                                        <Text style={{ fontSize: "18px", color: getConfig("colorPrimario") }}>{t("axesx")}</Text>
                                        <Input onChange={(e) => setEjeX(e.target.value)} value={ejeX} style={{ width: "90%" }} />
                                    </Flex>

                                    <Flex vertical align="center" style={{ width: "100%" }}>
                                        <Text style={{ fontSize: "18px", color: getConfig("colorPrimario") }}>{t("axesy")}</Text>
                                        <Input onChange={(e) => setEjeY(e.target.value)} value={ejeY} style={{ width: "90%" }} />
                                    </Flex>
                                </Flex>
                            }

                            {showFour==="3" &&
                                <Flex vertical style={{ width: "50%" }}>
                                    <Flex vertical align="center" style={{ width: "100%", marginBottom: "20px" }}>
                                        <Text style={{ fontSize: "18px", color: getConfig("colorPrimario") }}>{t("title")}</Text>
                                        <Input onChange={(e) => setTitle(e.target.value)} value={title} style={{ width: "90%" }} />
                                    </Flex>
                                </Flex>
                            }

                        </Flex>

                        <Flex gap={30} style={{ marginTop: "20px" }}>
                            <Button onClick={onNext} ghost style={{ width: "200px", color: getConfig("colorPrimario"), border: `1.5px solid ${getConfig("colorPrimario")}`, margin: "20px 0" }} loading={loading}>{t("create")}</Button>
                            <Button onClick={onBack} ghost style={{ width: "200px", color: getConfig("colorPrimario"), border: `1.5px solid ${getConfig("colorPrimario")}`, margin: "20px 0" }}>{t("back")}</Button>
                        </Flex>
                    </Flex>
                )}
            </div>
        )
    }



    return (
        <Flex style={{ width: "100%", height: "calc(100vh - 60px)", padding: "10px 0" }}>
            <div style={{ width: "100%", height: "100%", border: "1px solid #555050", borderRadius: "10px", overflow: "hidden" }}>
                <Phase1 />
                <Phase2 />
                <Phase3 />
                <Phase4 />
                <Phase5 />
            </div>

            {contextHolder}
        </Flex>
    )
}